export const IInfoCardsProperties = Object.freeze({
  picto: "picto",
  title: "title",
  type: "type",
});

export class InfoCardsPropertiesModel {
  constructor(data = {}) {
    this[IInfoCardsProperties.picto] = data[IInfoCardsProperties.picto];
    this[IInfoCardsProperties.title] = data[IInfoCardsProperties.title];
    this[IInfoCardsProperties.type] = data[IInfoCardsProperties.type];
  }

  getPicto() {
    return this[IInfoCardsProperties.picto];
  }

  getTitle() {
    return this[IInfoCardsProperties.title];
  }
  getType() {
    return this[IInfoCardsProperties.type];
  }
}
